export function ImgSrcChangePlugin(Vue, router, options) {
  Vue.directive("dynamic-src", {
    update: function update(el, binding, vnode) {
      var isloaded = el.getAttribute("isloaded"); //加载失败了

      if (isloaded === "false" || el.src !== binding.value) {
        el.src = ""; //先将图片置为空

        setTimeout(function () {
          el.src = binding.value;
        }, 0);
      }
    },
    bind: function bind(el, binding, vnode) {
      el.src = binding.value;

      el.onerror = function (element) {
        el.style.opacity = "0";
        el.setAttribute("isloaded", false);
      };

      el.onload = function (element) {
        el.style.opacity = "1";
        el.setAttribute("isloaded", true);
      };
    }
  });
}
export function ImageOnErrorPlugin(Vue) {
  Vue.directive("err-reload", {
    bind: function bind(el, binding) {
      var times = 0;

      el.onerror = function () {
        if (times < 3) {
          times++;
          el.src = binding.value;
        }
      };
    }
  });
}